export const profileSyncItemPseudoRadio = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncItemPseudoRadio.html',
    transclude: true,
    bindings: {
        selected: '<',
        onSelect: '&',
    },
};
